import Particle from './Particle';
import { random } from '@CS/utils/Number';

export default class Rectangle extends Particle {
  protected override readonly particleHeight = 8.0;
  protected override readonly particleWidth = 18.0;

  private readonly halfHeight = 4.0;
  private readonly halfWidth = 9.0;
  protected override fade = 0.0;

  public constructor(context: CanvasRenderingContext2D) {
    super(context);
  }

  protected override setDuration(): void {
    this.duration = random(2.5, 7.5);
  }

  protected override reset(): void {
    if (Rectangle.DropOnce) return;
    super.reset();
  }

  public override draw(): void {
    super.draw();

    const alpha = this.opacity.toFixed(2.0);
    this.context.fillStyle = `rgba(${this.rgb}, ${alpha})`;

    this.context.fillRect(
      -this.halfWidth,
      -this.halfHeight,
      this.particleWidth,
      this.particleHeight
    );

    this.context.restore();
  }
}
